import { render, staticRenderFns } from "./input-search.vue?vue&type=template&id=90a35c80&scoped=true&"
var script = {}
import style0 from "./input-search.vue?vue&type=style&index=0&id=90a35c80&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a35c80",
  null
  
)

export default component.exports